/**
 * Where to send the user right after creating a library (via a community
 * copy or a URL/file upload). `/library` (the list) is a clipper-only route
 * — an own_brand viewer landing there gets immediately bounced to /projects
 * by ObjectiveRoute, losing the library they just created. own_brand always
 * goes straight to the new library's clips page instead; clippers keep the
 * existing fallback (the list, optionally scoped to the community tab).
 */
export function resolveLibraryCreatedDestination(
  { objective, libraryId, fallback }: {
    objective?: string | null;
    libraryId: string;
    fallback: string;
  },
): string {
  if (objective === 'own_brand') {
    return `/library/${libraryId}/clips`;
  }
  return fallback;
}
